import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import NativeSelect from '@material-ui/core/NativeSelect';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core/';
import ColorPicker from './ColorPicker';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "100%",
        '& input': {
            textTransform:'uppercase'
        }
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width:"100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    errorMsg: {
        color: '#f44336',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '.8em',
        margin: '-8px 8px',

        '&:empty': {
            display: 'none'
        }
       
    }
});



const carColors = [{ id: 'white', name: 'White' },
{ id: 'silver', name: 'Silver' },
{ id: 'gray', name: 'Gray' },
{ id: 'black', name: "Black" },
{ id: 'dblue', name: "Dark Blue" },
{ id: 'lblue', name: "Light Blue" },
{ id: 'red', name: 'Red' },
{ id: 'brown', name: 'Brown' },
{ id: 'green', name: 'Green' },
{ id: 'maroon', name: 'Maroon' },
{ id: 'purple', name: 'Purple' },
{ id: 'orange', name: 'Orange' },
{ id: 'tan', name: 'Tan' },
{ id: 'gold', name: 'Gold' }];


export class Vehicle extends Component {

    state = {     
        make: this.props.item.make,
        model: this.props.item.model,
        color: this.props.item.color,
        errors: this.props.errors,
        models: [],
        years:[]
    };
    
    componentDidMount() {
      
    }   
     

    handleChange = name => event => {

        if (name === "color") {
            var colors = carColors.filter(x => x.name === event.target.value);
          
            if (colors && colors.length) {                
                this.handleColorChange(colors[0]);
            }

        } else {
            this.setState({ [name]: event.target.value }, () => {
                this.notifyParentChange(name);

                if (name === "make") {
                    var currentModel = this.state.model;
                    this.setState({ model: '' }, () => { currentModel && !this.state.make && this.notifyParentChange('model'); });
                }
            }); 
        }                   
    };

    handleColorChange(color) {
        this.setState({ color: color }, () => { this.notifyParentChange('color'); });
    }
   
    notifyParentChange = (n) => {
        setTimeout(() => {
            this.props.onVehicleChange(n, {
                id: this.props.item.id,               
                make: this.state.make,
                model: this.state.model,
                color: this.state.color,             
            });
        },200);
    };


    validateField = (name) => {
        setTimeout(() => {
            this.props.onBlur(name, { id: this.props.item.id, make: this.state.make, model: this.state.model, color: this.state.color});
        });
    }

    render() {
        const { classes } = this.props;
        
        return (
                <Grid fluid>
                <Row>
                    <Col sm={6}>     
                        <FormControl error={!!this.state.errors['make' + this.props.item.id]} className={classes.formControl}>
                            <InputLabel htmlFor={"vehicle-make" + this.props.item.id}>Make</InputLabel>
                            <NativeSelect
                                className="select-full-width"
                                value={this.state.make}                                
                                onChange={this.handleChange('make')}
                                onBlur={() => this.validateField('make')}
                                inputProps={{
                                    name: 'vehicle-make' + this.props.item.id,
                                    id: 'vehicle-make' + this.props.item.id,
                                }}
                            >
                               <option key={''} value="" />
                                {(this.props.vehicleList || []).map(make => {
                                    return <option key={make.name} value={make.name}>{make.name}</option>;
                                })}
                            </NativeSelect>                           
                        </FormControl>
                        <div className={classes.errorMsg}>{this.state.errors['make' + this.props.item.id]}</div>
                    </Col>
                    <Col sm={6}>
                        <FormControl error={!!this.state.errors['model' + this.props.item.id]} className={classes.formControl}>
                            <InputLabel htmlFor={"vehicle-model" + this.props.item.id}>Model</InputLabel>
                            <NativeSelect
                                value={this.state.model}
                                className="select-full-width"                               
                                onChange={this.handleChange('model')}
                                onBlur={() => this.validateField('model')}
                                inputProps={{
                                    name: 'vehicle-model' + this.props.item.id,
                                    id: 'vehicle-model' + this.props.item.id,
                                    }}
                            >
                                <option key={''} value="" />
                                {(this.props.vehicleList || []).filter(make => this.state.make === make.name)
                                    .map(make => make.models.map(model => {
                                            return <option key={model} value={model}>{model}</option>;
                                    }))
                                }               
                            </NativeSelect>   
                        </FormControl>
                        <div className={classes.errorMsg}>{this.state.errors['model' + this.props.item.id]}</div>
                    </Col>
                </Row>                      
                <Row>
                    <Col sm={12}>
                        
                        <FormControl error={!!this.state.errors['color' + this.props.item.id]}  className={classes.formControl}>
                            <InputLabel htmlFor={"vehicle-color" + this.props.item.id}>Color</InputLabel>
                            <NativeSelect
                                value={this.state.color.name}
                                className="select-full-width"
                                onChange={this.handleChange('color')}
                                onBlur={() => this.validateField('color')}
                                inputProps={{
                                    name: 'vehicle-color' + this.props.item.id,
                                    id: 'vehicle-color' + this.props.item.id
                                }}
                            >
                                {carColors.map(color => {
                                    return <option key={color.id} value={color.name}>{color.name}</option>;
                                })
                                }
                            </NativeSelect>                           
                        </FormControl>
                        <div className={classes.errorMsg}>{this.state.errors['color' + this.props.item.id]}</div>

                        <ColorPicker selectedColor={this.state.color} colors={carColors} onChange={(color) => { this.handleColorChange(color); }} />
                    </Col>
                </Row>
                </Grid>
        );
    }
}

Vehicle.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Vehicle);


// WEBPACK FOOTER //
// ./src/components/Vehicle.jsx